/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createChargePointConnectionFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, type ChargePointConnection, type ProblemDetails } from '../../../models/index.js';
// @ts-ignore
import { RefetchRequestBuilderRequestsMetadata, type RefetchRequestBuilder } from './refetch/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /chargepoints/{id}/connection
 */
export interface ConnectionRequestBuilder extends BaseRequestBuilder<ConnectionRequestBuilder> {
    /**
     * The refetch property
     */
    get refetch(): RefetchRequestBuilder;
    /**
     * GetChargePointConnection
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ChargePointConnection>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ChargePointConnection | undefined>;
    /**
     * GetChargePointConnection
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ConnectionRequestBuilderUriTemplate = "{+baseurl}/chargepoints/{id}/connection";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ConnectionRequestBuilderNavigationMetadata: Record<Exclude<keyof ConnectionRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    refetch: {
        requestsMetadata: RefetchRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const ConnectionRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: ConnectionRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createChargePointConnectionFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
